import { render, staticRenderFns } from "./SelectorIdiomes.vue?vue&type=template&id=93ab0298&scoped=true"
import script from "./SelectorIdiomes.vue?vue&type=script&lang=js"
export * from "./SelectorIdiomes.vue?vue&type=script&lang=js"
import style0 from "./SelectorIdiomes.vue?vue&type=style&index=0&id=93ab0298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ab0298",
  null
  
)

export default component.exports